import styled from 'styled-components';
import { OPACITY } from '@optimus-web/local-tokens';

interface DisabledProps {
    condition?: boolean;
}

export const DisabledComponent = styled.div<DisabledProps>`
    opacity: ${(props) => (props.condition ? OPACITY.disabled : 1)};
`;
